import Model, { attr } from '@ember-data/model';

export interface IExtraPriceSchema {
  name: string;
  type: string;
  amount: number;
}

export default class ExtraPriceModel extends Model {
  @attr('string') name!: string;
  @attr('string') type!: string;
  @attr('number') amount!: number;

  public toObject(): IExtraPriceSchema {
    return {
      name: this.name ?? null,
      type: this.type,
      amount: this.amount ?? null,
    };
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'extra-price': ExtraPriceModel;
  }
}
